import { ReactNode } from 'react'
import cn from 'classnames/bind'

import styles from './VisuallyHiding.scss'


const cx = cn.bind(styles)

type Props = {
  hiding: boolean
  children: ReactNode
}

export const VisuallyHiding = ({ hiding, children }: Props) => {
  return (
    <div className={cx({ hiding })}>{children}</div>
  )
}
